import { createReducer } from '@app/util';
import { RouterStateUrl } from '@util/routing';
import * as R from 'ramda';

export interface State {
  state: RouterStateUrl;
}

export const initialState: State = {
  state: null
};

export const reducer = createReducer<State, any>([], initialState);

export const getRouterState = (state: State) => R.prop('state', state);
export const getStateParams = R.prop('params');
export const getUrl = R.prop('url');
